var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_11126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51672 15.8998C1.12445 15.9226 0.738661 15.7922 0.440711 15.5361C-0.146904 14.945 -0.146904 13.9903 0.440711 13.3992L13.3075 0.532305C13.9187 -0.0395885 14.8777 -0.0077973 15.4496 0.603374C15.9668 1.15605 15.9969 2.00553 15.5202 2.59345L2.57756 15.5361C2.28346 15.7885 1.90386 15.9187 1.51672 15.8998Z",
    fill: "#currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3685 15.8998C13.9709 15.8981 13.5899 15.7403 13.3076 15.4603L0.440711 2.59337C-0.103684 1.95765 -0.0296705 1.00091 0.606055 0.456468C1.17346 -0.0294346 2.01026 -0.0294346 2.57761 0.456468L15.5203 13.3234C16.1313 13.8954 16.1629 14.8545 15.5908 15.4655C15.5681 15.4898 15.5446 15.5133 15.5203 15.5361C15.2033 15.8117 14.7863 15.9434 14.3685 15.8998Z",
    fill: "#currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_11126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.4d44c9d3d276ffb943c88669c25d7329.svg";
export { ForwardRef as ReactComponent };